import type { JSX } from 'react';
import { Box, styled } from '@mui/material';
import type { ITimelinePopupReportGroup } from '@/types/PatientDashboard/PatientTimeline.types';
import { getReportShortLabel } from './PatientTimeline.util';
import { MarkerDot } from './MarkerDotCluster.styles';
import ReportVersionLine from './ReportVersionLine';
import { PopupRow, PopupRowText } from './TimelinePopup.styles';

const GroupRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
});

interface IProps {
  group: ITimelinePopupReportGroup;
  patientId?: string;
}

export default function TimelinePopupReportGroup({ group, patientId }: IProps): JSX.Element {
  return (
    <GroupRoot>
      <PopupRow>
        <MarkerDot style={{ background: group.colour }} />
        <PopupRowText>{getReportShortLabel(group.type)}</PopupRowText>
      </PopupRow>
      {group.versions.map((version) => (
        <ReportVersionLine
          key={version.reportId}
          patientId={patientId}
          type={group.type}
          version={version}
        />
      ))}
    </GroupRoot>
  );
}
